module.exports = __webpack_public_path__ + "img/1200.20b02ddc.gif";